<!-- ══════════════════════════════════════════
     SIGN IN SCREEN
══════════════════════════════════════════ -->
<section class="signin-section" *ngIf="showSignIn">
  <div class="grid-bg"></div>
  <div class="signin-wrapper">
    <div class="signin-brand">
      <div style="font-size: 44px; margin-bottom: 12px;">✈️</div>
      <h1>Shamudri Tourism</h1>
      <p class="tagline">OFFICIAL BOOKING PORTAL</p>
    </div>

    <div class="signin-card">
      <div class="signin-card-header">
        <div class="icon-box">🔐</div>
        <div>
          <h2>Welcome Back</h2>
          <p *ngIf="pendingLoginAction === 'dashboard'">Sign in to view your bookings</p>
          <p *ngIf="pendingLoginAction === 'submit'">Sign in to complete your booking submission</p>
          <p *ngIf="pendingLoginAction !== 'dashboard' && pendingLoginAction !== 'submit'">Sign in to access the booking portal</p>
        </div>
      </div>

      <div class="signin-body">
        <div class="input-group">
          <label>Email Address</label>
          <input
            type="email"
            [(ngModel)]="signInEmail"
            name="signInEmail"
            placeholder="you@example.com"
            (keyup.enter)="signIn()"
            [class.input-error]="signInError"
          >
        </div>

        <div class="input-group" style="position: relative;">
          <label>Password</label>
          <input
            [type]="showPassword ? 'text' : 'password'"
            [(ngModel)]="signInPassword"
            name="signInPassword"
            placeholder="Enter your password"
            (keyup.enter)="signIn()"
            [class.input-error]="signInError"
            style="padding-right: 50px;"
          >
          <button
            type="button"
            class="toggle-password-btn"
            (click)="toggleShowPassword()"
            [attr.aria-label]="showPassword ? 'Hide password' : 'Show password'"
          >
            {{ showPassword ? '🙈' : '👁️' }}
          </button>
        </div>

        <div class="signin-error" *ngIf="signInError">
          ⚠️ {{ signInError }}
        </div>

        <button
          class="signin-btn"
          [disabled]="isSigningIn"
          (click)="signIn()"
        >
          <span *ngIf="!isSigningIn">Sign In →</span>
          <span *ngIf="isSigningIn" class="signin-spinner">Signing in...</span>
        </button>
        <button type="button" class="back-btn" (click)="pendingLoginAction === 'submit' ? openForm() : (showSignIn=false)">← Back</button>
      </div>
    </div>
  </div>
</section>


<!-- ══════════════════════════════════════════
     HERO SECTION (shown after sign-in)
══════════════════════════════════════════ -->
<section class="hero-section" *ngIf="!showSignIn && !showForm && !showDashboard">
    <div class="top-navbar">
      <button class="nav-btn" (click)="goToDashboard()">📊 Dashboard</button>
      
    </div>

    <div class="grid-bg"></div>
    <div class="hero-content">
        <div style="font-size: 50px; margin-bottom: 15px;">✈️</div>
        <h1>Shamudri Tourism</h1>
        <p class="tagline">DISCOVER THE WORLD WITH US</p>
        <div class="hero-card">
            <div class="badge">Shamudri Tourism • Official Booking Portal</div>
            <h2>Your <span>Dream Trip</span><br>Starts Here</h2>
            <p>Fill your travel details, choose package and submit your booking instantly.</p>
            <button (click)="openForm()">Open Booking Form</button>
        </div>
    </div>
</section>


<!-- ══════════════════════════════════════════
     BOOKING FORM
══════════════════════════════════════════ -->
<section class="form-section" *ngIf="showForm && !showDashboard">
    

    <div class="form-container">
        <div class="form-header">
            <div class="icon-box">📄</div>
            <div>
                <h2>{{ editingBookingId ? 'Edit Booking' : 'Travel Booking Form' }}</h2>
                <p>Shamudri Tourism • {{ editingBookingId ? 'Update your details' : 'Fill your details' }}</p>
            </div>
            <button *ngIf="editingBookingId" type="button" class="back-to-dashboard-btn" (click)="cancelEdit()">← Back to Dashboard</button>
        </div>

        <div>
            <div class="form-block">
                <h3>TRAVELER INFORMATION</h3>
                <div class="grid-1">
                    <div class="input-group">
                        <label>Full Name</label>
                        <input type="text" name="fullName" [(ngModel)]="fullName" required>
                    </div>
                    <div class="input-group">
                        <label>Email Address</label>
                        <input type="email" name="email" [(ngModel)]="email" required>
                    </div>
                    <div class="input-group">
                        <label>Passport Country</label>
                        <input type="text" name="passport" [(ngModel)]="passport">
                    </div>
                    <div class="input-group">
                        <label>Country Code</label>
                        <div class="cc-dropdown">
                            <div class="cc-backdrop" *ngIf="showDropdown" (click)="closeDropdownExplicit()"></div>
                            <div class="cc-selected" tabindex="0" (click)="toggleDropdown($event)">
                                <span class="cc-flag-code">{{selectedCountry.flag}} {{selectedCountry.code}}
                                    {{selectedCountry.name}}</span>
                                <span class="cc-arrow" [class.open]="showDropdown">▾</span>
                            </div>
                            <div class="cc-panel" [class.open]="showDropdown" (click)="$event.stopPropagation()">
                                <div class="cc-search-wrap">
                                    <input type="text" class="cc-search-input" name="countrySearch"
                                        [(ngModel)]="countrySearch" (input)="filterCountries()"
                                        placeholder="🔍 Search country or code...">
                                </div>
                                <ul class="cc-list">
                                    <li *ngFor="let c of filteredCountries" (click)="selectCountry(c)">
                                        {{c.flag}} <strong>{{c.code}}</strong> {{c.name}}
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div class="input-group">
                        <label>Phone Number</label>
                        <div class="phone-input-wrapper">
                            <span class="phone-prefix">{{selectedCountry.code}}</span>
                            <input type="tel" name="phoneNumber" [(ngModel)]="phoneNumber" placeholder="Enter number"
                                required>
                        </div>
                    </div>
                    <div class="input-group">
                        <label>Destination</label>
                        <input type="text" name="destination" [(ngModel)]="destination" required>
                    </div>
                    <div class="input-group">
                        <label>Adults</label>
                        <input type="number" name="adultsCount" [(ngModel)]="adultsCount" min="1" placeholder="0">
                    </div>
                    <div class="input-group">
                        <label>Children (Below 12 Years)</label>
                        <input type="number" name="childrenBelow12" [(ngModel)]="childrenBelow12" min="0"
                            placeholder="0">
                    </div>
                    <div class="input-group">
                        <label>Arrival Date</label>
                        <input type="date" name="arrivalDate" [(ngModel)]="arrivalDate" [min]="today"
                            (change)="onArrivalChange()">
                    </div>
                    <div class="input-group">
                        <label>Departure Date</label>
                        <input type="date" name="departureDate" [(ngModel)]="departureDate" [min]="arrivalDate || today"
                            (change)="onDepartureChange()">
                    </div>
                </div>
            </div>

            <div class="form-block">
                <h3>STAY DURATION</h3>
                <div class="slider-area">
                    <input type="range" name="durationDays" min="0" max="30" [(ngModel)]="durationDays"
                        (input)="onSliderChange()">
                    <div class="days-box">
                        <span>{{durationDays}} Night<ng-container *ngIf="durationDays !== 1">s</ng-container></span>
                    </div>
                </div>
            </div>

            <div class="form-block" *ngIf="itinerary.length > 0">
                <h3>DAYWISE ITINERARY PLAN</h3>
                <div id="itineraryContainer">
                    <div class="itinerary-day" *ngFor="let day of itinerary; let i = index">
                        <div class="day-title">Day {{i + 1}} Plan</div>
                        <div class="day-grid">
                            <div class="input-group">
                                <label>Day Title</label>
                                <input type="text" class="dayTitle" name="dayTitle{{i}}" [(ngModel)]="day.title"
                                    placeholder="e.g. City Tour">
                            </div>
                            <div class="input-group">
                                <label>Activities</label>
                                <div class="activity-list-container">
                                    <div class="activity-entry-row"
                                        *ngFor="let act of day.activities; let aIdx = index">
                                        <div class="activity-entry-fields">
                                            <input type="text" class="activity-title-input"
                                                name="actTitle{{i}}_{{aIdx}}" [(ngModel)]="act.title"
                                                placeholder="Activity title">
                                            <select class="activity-transport-mode" name="actMode{{i}}_{{aIdx}}"
                                                [(ngModel)]="act.transportMode">
                                                <option value="">Transport Mode</option>
                                                <option value="Private Transport Mode">Private Transport Mode</option>
                                                <option value="Sharing Transport Mode">Sharing Transport Mode</option>
                                                <option value="Walking">Walking</option>
                                                <option value="Public Transport Mode">Public Transport Mode</option>
                                            </select>
                                            <input type="number" class="activity-cost-input"
                                                name="actCost{{i}}_{{aIdx}}" [(ngModel)]="act.cost" min="0"
                                                placeholder="Cost (AED)">
                                            <button type="button" class="remove-activity-btn"
                                                (click)="removeActivity(i, aIdx)">✕</button>
                                        </div>
                                    </div>
                                </div>
                                <button type="button" class="add-activity-btn" (click)="addActivity(i)">+ Add
                                    Activity</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="form-block">
                <h3>HOTEL DETAILS</h3>
                <div class="hotel-table-wrapper">
                    <table class="hotel-input-table">
                        <thead>
                            <tr>
                                <th>Hotel Name</th>
                                <th>Category</th>
                                <th>Place</th>
                                <th>Check In</th>
                                <th>Check Out</th>
                                <th>No. of Rooms</th>
                                <th>No of extra beds</th>
                                <th>Services</th>
                                <th>Cost (AED)</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr class="hotel-row" *ngFor="let hotel of hotels; let i = index">
                                <td data-label="Hotel Name"><input type="text" name="hName{{i}}"
                                        [(ngModel)]="hotel.name" placeholder="Hotel name"></td>
                                <td data-label="Category"><input type="text" name="hCat{{i}}"
                                        [(ngModel)]="hotel.category" placeholder="e.g. 3 Star"></td>
                                <td data-label="Place"><input type="text" name="hPlace{{i}}" [(ngModel)]="hotel.place"
                                        placeholder="City / Area"></td>
                                <td data-label="Check In"><input type="date" name="hCheckIn{{i}}"
                                        [(ngModel)]="hotel.checkIn" [min]="today"
                                        (change)="onHotelCheckInChange(hotel)"></td>
                                <td data-label="Check Out"><input type="date" name="hCheckOut{{i}}"
                                        [(ngModel)]="hotel.checkOut" [min]="hotel.checkIn || today"
                                        (change)="onHotelCheckOutChange(hotel)"></td>
                                <td data-label="No. of Rooms"><input type="number" name="hRooms{{i}}"
                                        [(ngModel)]="hotel.rooms" min="1" placeholder="1"></td>
                                <td data-label="No of extra beds"><input type="number" name="hExtraBeds{{i}}"
                                        [(ngModel)]="hotel.extraBeds" min="0" placeholder="0"></td>
                                <td data-label="Services">
                                  <select name="hServices{{i}}" [(ngModel)]="hotel.services">
                                    <option value="">Select</option>
                                    <option value="Breakfast">Breakfast</option>
                                    <option value="Breakfast & Lunch">Breakfast &amp; Lunch</option>
                                    <option value="Breakfast, Lunch & Dinner">Breakfast, Lunch &amp; Dinner</option>
                                    <option value="Breakfast & Dinner">Breakfast &amp; Dinner</option>
                                    <option value="Lunch & Dinner">Lunch &amp; Dinner</option>
                                  </select>
                                </td>
                                <td data-label="Cost (AED)"><input type="number" name="hCost{{i}}"
                                        [(ngModel)]="hotel.cost" min="0" placeholder="0.00"></td>
                                <td>
                                    <button *ngIf="hotels.length > 1" type="button" class="remove-hotel-btn"
                                        (click)="removeHotel(i)">Delete</button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <div class="hotel-table-footer">
                        <button type="button" class="add-hotel-btn" (click)="addHotel()">+ Add Hotel</button>
                    </div>
                </div>
            </div>

            <div class="form-block">
                <h3>PRICING</h3>
                <div class="pricing-summary">
                    <div class="price-row">
                        <span class="price-label">✈️ Travel Cost</span>
                        <span class="currency">AED</span>
                        <span class="price-auto-display">{{travelCost | number:'1.2-2'}}</span>
                    </div>
                    <div class="price-row">
                        <span class="price-label">🏨 Hotel Cost</span>
                        <span class="currency">AED</span>
                        <span class="price-auto-display">{{hotelCost | number:'1.2-2'}}</span>
                    </div>
                    <div class="total-row">
                        <span class="price-label">💰 Overall Pricing</span>
                        <span class="total-price">AED {{overallPrice | number:'1.2-2'}}</span>
                    </div>
                </div>
            </div>

            <div class="form-block">
                <h3>SPECIAL REQUESTS & NOTES</h3>
                <textarea name="specialRequests" [(ngModel)]="specialRequests"></textarea>
            </div>

            <div class="form-actions-row" *ngIf="editingBookingId; else newBookingSubmit">
                <button type="button" class="submit-btn" [disabled]="isLoading" (click)="submitForm()">
                    {{ isLoading ? 'Updating...' : 'Update Booking' }}
                </button>
                <button type="button" class="cancel-edit-btn" [disabled]="isLoading" (click)="cancelEdit()">
                    ✕ Cancel Edit
                </button>
            </div>
            <ng-template #newBookingSubmit>
                <button type="button" class="submit-btn" [disabled]="isLoading" (click)="submitForm()">
                    {{ isLoading ? 'Submitting...' : 'Submit Booking' }}
                </button>
            </ng-template>
        </div>
    </div>
</section>


<!-- ══════════════════════════════════════════
     DASHBOARD
══════════════════════════════════════════ -->
<section class="dashboard-section" *ngIf="isAuthenticated && showDashboard">
  <div class="dashboard-topbar">
    <div class="dashboard-topbar-brand">
      <span class="dashboard-topbar-logo">✈️</span>
      <span class="dashboard-topbar-name">Shamudri Tourism</span>
    </div>
    <div class="dashboard-topbar-actions">
      <button class="dash-new-btn" (click)="openForm()">
        <span class="dash-new-btn-icon">＋</span> New Booking
      </button>
      <button class="dash-signout-btn" (click)="signOut()">Sign Out</button>
    </div>
  </div>

  <div class="dashboard-container">
    <!-- Header -->
    <div class="dashboard-header">
      
      <div class="dashboard-header-icon">📋</div>
      <div class="dashboard-header-text">
        <h1>Bookings Dashboard</h1>
        <p>All itinerary records — Shamudri Tourism</p>
      </div>
      <div class="dashboard-header-badge" *ngIf="!isDashboardLoading && dashboardBookings.length > 0">
        {{ dashboardBookings.length }} record{{ dashboardBookings.length !== 1 ? 's' : '' }}
      </div>
    </div>

    <!-- Search -->
    <div class="dash-search-bar" *ngIf="!isDashboardLoading && dashboardBookings.length > 0">
      <div class="dash-search-wrap">
        <span class="dash-search-icon">🔍</span>
        <input
          type="text"
          class="dash-search-input"
          [(ngModel)]="searchQuery"
          (ngModelChange)="onSearchChange()"
          placeholder="Search by name or phone number..."
        >
        <button *ngIf="searchQuery" class="dash-search-clear" (click)="clearSearch()">✕</button>
      </div>
      <span class="dash-search-count" *ngIf="searchQuery">
        {{ filteredBookings.length }} result{{ filteredBookings.length !== 1 ? 's' : '' }}
      </span>
    </div>

    <!-- Loading -->
    <div *ngIf="isDashboardLoading" class="dashboard-loading">
      <div class="dash-spinner"></div>
      <p>Loading bookings...</p>
    </div>

    <!-- Empty -->
    <div *ngIf="!isDashboardLoading && filteredBookings.length === 0" class="dashboard-empty-state">
      <div class="dashboard-empty-icon">{{ searchQuery ? '🔍' : '📭' }}</div>
      <p>{{ searchQuery ? 'No results found' : 'No bookings found' }}</p>
      <span>{{ searchQuery ? 'Try a different name' : 'New bookings will appear here after submission' }}</span>
    </div>

    <!-- Table Header -->
    <div class="dash-table-header" *ngIf="!isDashboardLoading && filteredBookings.length > 0">
      <span class="dash-col-num">#</span>
      <span class="dash-col-name">Traveller</span>
      <span class="dash-col-phone">Phone</span>
      <span class="dash-col-dest">Destination</span>
      <span class="dash-col-dates">Arrival</span>
      <span class="dash-col-dates">Departure</span>
      <span class="dash-col-edit">Edit</span>
      <span class="dash-col-actions">Itinerary PDF</span>
      <span class="dash-col-delete">Delete</span>
    </div>

    <!-- Booking Rows -->
    <div class="dash-table-body" *ngIf="!isDashboardLoading && filteredBookings.length > 0">
      <div class="dash-row" *ngFor="let booking of pagedBookings; let i = index">
        <span class="dash-col-num">
          <span class="dash-num-badge">{{ (currentPage - 1) * pageSize + i + 1 }}</span>
        </span>
        <span class="dash-col-name">
          <span class="dash-traveller-name">{{ booking.fullName }}</span>
        </span>
        <span class="dash-col-phone">
          <span class="dash-phone-val">{{ booking.phone || '—' }}</span>
        </span>
        <span class="dash-col-dest">
          <span class="dash-dest-pill">📍 {{ booking.destination }}</span>
        </span>
        <span class="dash-col-dates">
          <span class="dash-date-label">Arrival</span>
          <span class="dash-date-pill">{{ booking.arrivalDate || '—' }}</span>
        </span>
        <span class="dash-col-dates">
          <span class="dash-date-label">Departure</span>
          <span class="dash-date-pill">{{ booking.departureDate || '—' }}</span>
        </span>
        <span class="dash-col-edit">
          <button
            class="dash-edit-btn"
            [disabled]="isLoadingBookingForEdit"
            (click)="editBooking(booking.id)">
            <span *ngIf="!isLoadingBookingForEdit">✎ Edit</span>
            <span *ngIf="isLoadingBookingForEdit">...</span>
          </button>
        </span>
        <span class="dash-col-actions">
          <button class="dash-pdf-btn dash-pdf-with" (click)="downloadDashboardPdf(booking.documentId, true)">
            <span class="dash-pdf-btn-icon">⬇</span>
            <span>With Cost</span>
          </button>
          <button class="dash-pdf-btn dash-pdf-without" (click)="downloadDashboardPdf(booking.documentId, false)">
            <span class="dash-pdf-btn-icon">⬇</span>
            <span>Without Cost</span>
          </button>
        </span>
        <span class="dash-col-delete">
          <button
            class="dash-delete-btn"
            [disabled]="isDeleting"
            (click)="requestDelete(booking)">
            🗑 Delete
          </button>
        </span>
      </div>
    </div>

    <!-- Pagination -->
    <div class="dash-pagination" *ngIf="!isDashboardLoading && totalPages > 1">
      <button class="dash-page-btn" [disabled]="currentPage === 1" (click)="goToPage(currentPage - 1)">‹ Prev</button>
      <button
        class="dash-page-btn"
        *ngFor="let page of pageNumbers"
        [class.active]="page === currentPage"
        (click)="goToPage(page)">
        {{ page }}
      </button>
      <button class="dash-page-btn" [disabled]="currentPage === totalPages" (click)="goToPage(currentPage + 1)">Next ›</button>
    </div>

  </div>
</section>

<!-- PDF VIEWER MODAL -->
<div class="pdf-viewer-overlay" *ngIf="showPdfViewer" (click)="closePdfViewer()">
  <div class="pdf-viewer-modal" (click)="$event.stopPropagation()">
    <div class="pdf-viewer-header">
      <div class="pdf-viewer-title">
        <span class="pdf-viewer-icon">📄</span>
        <span>{{ pdfViewerTitle }}</span>
      </div>
      <div class="pdf-viewer-header-actions">
        <button *ngIf="!isDashboardPdfLoading && pdfViewerUrl" (click)="downloadViewerPdf()" class="pdf-viewer-download">⬇ Download</button>
        <button class="pdf-viewer-close" (click)="closePdfViewer()">
          <span>✕</span> Close
        </button>
      </div>
    </div>
    <div class="pdf-viewer-body">
      <div *ngIf="isDashboardPdfLoading" class="pdf-loading">
        <div class="pdf-loading-ring">
          <div class="pdf-loading-ring-track"></div>
          <div class="pdf-loading-ring-fill"></div>
          <span class="pdf-loading-ring-icon">📄</span>
        </div>
        <p class="pdf-loading-title">Preparing your document</p>
        <span class="pdf-loading-sub">Fetching itinerary from server...</span>
        <div class="pdf-loading-bar">
          <div class="pdf-loading-bar-fill"></div>
        </div>
      </div>
      <iframe
        *ngIf="!isDashboardPdfLoading && pdfViewerUrl"
        [src]="pdfViewerUrl"
        class="pdf-iframe"
        type="application/pdf"
      ></iframe>
      <div *ngIf="!isDashboardPdfLoading && pdfViewerUrl" class="pdf-toolbar-blocker" (click)="downloadViewerPdf()"></div>
    </div>
  </div>
</div>

<!-- PDF DOWNLOAD POPUP -->
<div class="popup-overlay" *ngIf="showPdfPopup">
    <div class="popup-box pdf-popup">
        <div class="pdf-popup-icon">📄</div>
        <h2>Booking Confirmed!</h2>
        <p>Your booking was saved successfully.<br>How would you like to download your itinerary PDF?</p>
        <div class="pdf-popup-buttons">
            <button class="pdf-btn pdf-btn-with" [disabled]="isPdfLoading" (click)="downloadPdf(true)">
                <span *ngIf="pdfLoadingType !== 'with'">💰 Download with Cost</span>
                <span *ngIf="pdfLoadingType === 'with'">Downloading...</span>
            </button>
            <button class="pdf-btn pdf-btn-without" [disabled]="isPdfLoading" (click)="downloadPdf(false)">
                <span *ngIf="pdfLoadingType !== 'without'">📋 Download without Cost</span>
                <span *ngIf="pdfLoadingType === 'without'">Downloading...</span>
            </button>
            <button class="pdf-btn pdf-btn-close" [disabled]="isPdfLoading" (click)="closePdfPopup()">
                ✕ Close & Finish
            </button>
        </div>
    </div>
</div>

<!-- SOFT DELETE CONFIRMATION POPUP -->
<div class="popup-overlay" *ngIf="confirmDeleteId !== null">
    <div class="popup-box delete-popup">
        <div class="delete-popup-icon">🗑️</div>
        <h2>Delete Booking?</h2>
        <p>
            This will remove <strong>{{ confirmDeleteName }}</strong>'s booking from the dashboard.
        </p>
        <div class="pdf-popup-buttons">
            <button class="pdf-btn delete-btn-confirm" [disabled]="isDeleting" (click)="confirmDelete()">
                <span *ngIf="!isDeleting">🗑 Confirm Delete</span>
                <span *ngIf="isDeleting">Deleting...</span>
            </button>
            <button class="pdf-btn pdf-btn-close" [disabled]="isDeleting" (click)="cancelDelete()">
                ✕ Cancel
            </button>
        </div>
    </div>
</div>

<!-- TOAST NOTIFICATION -->
<div class="toast" [class.toast-show]="showToast">
    <span class="toast-icon">✅</span>
    <span class="toast-msg">Submitted Successfully!</span>
</div>